import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { AuthProvider } from './contexts/AuthContext';
import { FeaturesProvider } from './contexts/FeaturesContext';
import { MaintenanceProvider } from './contexts/MaintenanceContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { OfflineSyncProvider } from './contexts/OfflineSyncContext';
import { PwaOfflineBanner } from './components/PwaOfflineBanner';
import { PlayStoreInstallBanner } from './components/PlayStoreInstallBanner';
import { MaintenanceGate } from './components/MaintenanceGate';
import { ErrorAlertToastBridge } from './components/ui/ErrorAlertToastBridge';
import { ToastProvider } from './components/ui/ToastProvider';
import { LimitReachedModalProvider } from './contexts/LimitReachedModalContext';
import { App } from './App';
import { captureClientChannelFromUrl } from './lib/clientChannel';
import './index.css';

declare global {
  interface Window {
    __FDH_UNSUPPORTED_BROWSER__?: boolean;
  }
}

const bootstrapApp = () => {
  if (window.__FDH_UNSUPPORTED_BROWSER__) {
    return;
  }

  captureClientChannelFromUrl();
  registerSW({ immediate: true });

  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Root element not found');

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <FeaturesProvider>
            <MaintenanceProvider>
              <LanguageProvider>
                <ThemeProvider>
                  <OfflineSyncProvider>
                    <ToastProvider>
                      <LimitReachedModalProvider>
                        <PwaOfflineBanner />
                        <PlayStoreInstallBanner />
                        <ErrorAlertToastBridge />
                        <MaintenanceGate>
                          <App />
                        </MaintenanceGate>
                      </LimitReachedModalProvider>
                    </ToastProvider>
                  </OfflineSyncProvider>
                </ThemeProvider>
              </LanguageProvider>
            </MaintenanceProvider>
          </FeaturesProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
};

bootstrapApp();

